import React from 'react';
import styled, {css} from 'styled-components';

import {FormLabel} from '../../../ui-toolkit/form-v2/form-labels/FormLabel';
import {FormGroup} from '../../../ui-toolkit/form-v2/form-containers/FormGroup';
import {Icon} from '../../../ui-toolkit/elements/Icon/Icon';
import {LabeledPrefix, LabeledSuffix} from '../../../ui-toolkit/form-v2/form-labels/FormLabeledSuffixPrefix';

const IconContainer = styled.span`
    color: ${({color}) => color};
    display: flex;
    align-items: center;
`;

export const EditorDetail = ({label, direction, children, isCardEditor, isArrayFormatter, icon}) => (
    <DetailFormGroup direction={direction} isCardEditor={isCardEditor} isArrayFormatter={isArrayFormatter}>
        {(label || icon) && (
            <FormLabel>
                {label}
                {icon && (
                    <IconContainer color={icon.color}>
                        <Icon name={icon.icon} color={icon.color} />
                        {icon.tooltip}
                    </IconContainer>
                )}
            </FormLabel>
        )}
        <div>{children}</div>
    </DetailFormGroup>
);

export const DetailFormGroup = styled(FormGroup)`
    color: var(--default-text-color);
    margin-bottom: var(--space-sm);
    ${FormLabel} {
        margin: 0;
        padding: 0;
        &:has(${IconContainer.toString()}) {
            display: flex;
            justify-content: space-between;
            ${Icon.Wrapper} {
                margin-bottom: 2px;
            }
        }
    }
    ${LabeledSuffix},
    ${LabeledPrefix} {
        padding: 0 var(--padding-form-control);
    }
    ${({direction}) => {
        if (direction == 'horz') {
            return css`
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                gap: var(--space-xsm);
                > div {
                    display: flex;
                    flex-wrap: wrap;
                    align-items: center;
                    gap: var(--space-xsm);
                }
            `;
        } else return;
    }}

    ${({isCardEditor, isArrayFormatter}) => {
        if (isCardEditor)
            return css`
                > span,
                > ${FormLabel} {
                    color: var(--default-text-color);
                    margin-top: 20px;
                    font-size: var(--text-size-default);
                    font-weight: 800;
                }
            `;
        else if (isArrayFormatter)
            return css`
                > span,
                > ${FormLabel} {
                    color: var(--default-text-color);
                    margin-top: 20px;
                    font-size: var(--text-size-default);
                    font-weight: 800;
                }
            `;
        else return ``;
    }}
`;
